import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    height: '100%'
  }
})

export default useStyles
